import React from 'react';
import { Box, Card, CardContent, Typography, Stack, Avatar } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { LoadingWrapper } from '../loading';
import useResponsive from '../../hooks/useResponsive';

const EmployeeDashboardStatsCards = ({ attendanceStats, leaveStats, payrollStats, isLoading }) => {
  const mdUp = useResponsive('up', 'md');

  const statsCards = [
    {
      title: 'Average Attendance',
      value: `${attendanceStats?.average_attendance || 0}%`,
      icon: <AccessTimeIcon />,
      color: 'success.main',
    },
    {
      title: 'Pending Leaves',
      value: leaveStats?.pending_leaves || 0,
      icon: <BeachAccessIcon />,
      color: 'warning.main',
    },
    {
      title: 'Monthly Payroll',
      value: `PKR ${(payrollStats?.total_net_pay || 0).toLocaleString()}`,
      icon: <AttachMoneyIcon />,
      color: 'info.main',
    },
  ];

  return (
    <LoadingWrapper
      isLoading={isLoading}
      loadingType="skeleton"
      skeletonCount={3}
      gridProps={{ xs: 12, sm: 6, md: 4 }}
      containerSx={{ marginY: 0 }}
    >
      <Box
        display={mdUp ? 'flex' : 'block'}
        alignItems="stretch"
        gap={2}
        marginY={0}
        width="100%"
      >
        {statsCards.map((stat, index) => (
          <Card
            key={index}
            sx={{
              minWidth: 200,
              flex: 1,
              marginBottom: mdUp ? 0 : 2,
              position: 'relative',
              overflow: 'visible',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="subtitle2" color="text.secondary">
                  {stat.title}
                </Typography>
                <Avatar sx={{ bgcolor: stat.color, color: 'white' }}>{stat.icon}</Avatar>
              </Stack>

              <Typography variant="h4">{stat.value}</Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </LoadingWrapper>
  );
};

export default EmployeeDashboardStatsCards;
